import { createAction, props } from '@ngrx/store';

export const syncCalendars = createAction('[Common Calendar Sync] Sync', props<{ vendor?: 'Microsoft' | 'Google' }>());
